import React, { useState, useEffect } from "react";
import API from "../Services/api";
import CollectionPointMap from './CollectionPoints/CollectionPointMap';
import SubmitRequestPopup from './CollectionPoints/SubmitRequestPopup';
import Header from "./Header";
import Footer from "./Footer";

const FullPageMap = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [selectedPoint, setSelectedPoint] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [isBookmarked, setIsBookmarked] = useState(false);
  const [pendingItems, setPendingItems] = useState(null);
  const [autoOpenRecycling, setAutoOpenRecycling] = useState(false);

  const params = new URLSearchParams(window.location.search);
  const searchQuery = params.get('q') || '';
  const restoreRecycling = params.get('restore') === 'recycling';

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setIsAuthenticated(true);
      API.get("/users/profile")
        .then(({ data }) => setUser(data))
        .catch(() => setIsAuthenticated(false));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (restoreRecycling) {
      const stored = sessionStorage.getItem('pendingRecyclingState');
      if (stored) {
        try {
          const { collectionPoint, items } = JSON.parse(stored);
          if (collectionPoint) {
            setSelectedPoint(collectionPoint);
            setShowPopup(true);
            setAutoOpenRecycling(true);
            setPendingItems(items || null);
            sessionStorage.removeItem('pendingRecyclingState');
            window.history.replaceState({}, '', '/map');
          }
        } catch (e) {
          sessionStorage.removeItem('pendingRecyclingState');
        }
      }
    }

    setIsLoading(false);
  }, []);

  const handleMarkerClick = (point) => {
    setSelectedPoint(point);
    const bookmarked = user?.bookmarkedLocations?.some(
      (id) => id === point._id || id?.toString() === point._id?.toString()
    ) || false;
    setIsBookmarked(bookmarked);
    setAutoOpenRecycling(false);
    setPendingItems(null);
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    setAutoOpenRecycling(false);
    setPendingItems(null);
  };

  const updateBookmarks = (pointId, added) => {
    setUser((prev) => {
      if (!prev) return prev;
      const locs = prev.bookmarkedLocations || [];
      return {
        ...prev,
        bookmarkedLocations: added
          ? [...locs, pointId]
          : locs.filter((id) => id !== pointId && id?.toString() !== pointId?.toString()),
      };
    });
  };

  return (
    <div className="min-h-screen flex flex-col">
      {isLoading ? (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-white bg-opacity-75">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-[#29752B]"></div>
        </div>
      ) : (
        <div className="flex flex-col h-screen">
          <Header isDashboard={false} isAuthenticated={isAuthenticated} user={user} />

          <div className="relative flex-1 overflow-hidden">
            <CollectionPointMap
              onMarkerClick={handleMarkerClick}
              initialSearchQuery={searchQuery}
            />

            {showPopup && selectedPoint && (
              <SubmitRequestPopup
                onClose={handleClosePopup}
                collectionPoint={selectedPoint}
                isBookmarked={isBookmarked}
                updateBookmarks={updateBookmarks}
                autoOpenRecycling={autoOpenRecycling}
                pendingItems={pendingItems}
              />
            )}
          </div>

          <div className="hidden sm:block"><Footer /></div>
        </div>
      )}
    </div>
  );
};

export default FullPageMap;
